import { createSlice } from '@reduxjs/toolkit';
import { login, logOut, refresh, updateUserInfo } from './operations';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

const initialState = {
  token: null,
  isSignedIn: false,
  user: null,
  balance: 0,
};

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};
const handleRejected = (state, { payload }) => {
  state.isLoading = false;
  state.error = payload;
  state.token = null;
  state.isSignedIn = null;
  state.user = null;
};

export const sliceAuth = createSlice({
  name: 'Auth',

  initialState,
  reducers: {
    updateUser: (state, action) => {
      const updatedUser = action.payload;

      state.user = updatedUser;
    },
    updateUserBalance: (state, action) => {
      const balance = action.payload;

      state.balance = Math.max(0, balance);
    },
  },
  extraReducers: builder => {
    builder
      .addCase(login.fulfilled, (state, { payload: userData }) => {
        state.isLoading = false;
        state.error = null;
        state.token = userData.token;
        state.user = userData.user;
        state.isSignedIn = true;
        state.balance = userData.user.balance;
      })
      .addCase(updateUserInfo.fulfilled, (state, { payload: userData }) => {
        state.user = userData;
        state.isLoading = false;
        state.error = null;
        state.balance = userData.balance;
      })

      .addCase(refresh.fulfilled, (state, { payload: userData }) => {
        state.isLoading = false;
        state.error = null;
        state.token = userData.token;
        state.user = userData.user;
        state.isSignedIn = true;
      })

      .addCase(logOut.fulfilled, state => {
        state.isLoading = false;
        state.error = null;
        state.token = null;
        state.user = null;
        state.isSignedIn = false;
      })
      .addCase(login.pending, handlePending)
      .addCase(login.rejected, handleRejected)
      .addCase(refresh.pending, handlePending)
      .addCase(refresh.rejected, handleRejected)
      .addCase(logOut.pending, handlePending)
      .addCase(logOut.rejected, handleRejected);
  },
});
const persistConfig = {
  key: 'root',
  storage: storage,
};
export const { updateUser, updateUserBalance } = sliceAuth.actions;
export default persistReducer(persistConfig, sliceAuth.reducer);
